import cloneDeep from 'lodash/cloneDeep';
import {MigrationManifest, PersistedState} from 'redux-persist';

import {StoreVersions} from './types/Store';

export const migrations: MigrationManifest = {
  0: state => {
    const store = cloneDeep(state) as PersistedState & StoreVersions[0]['ble'];

    return {
      ...store,
      devices: store.devices.map(d => ({
        ...d,
        heatProfiles: d.heatProfiles ?? [],
        lantern: {on: false},
      })),
    };
  },
};

export const migrationVersion = 0;
